export default "__VITE_ASSET__CajxF99h__"